var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60286 0.0566406C4.76953 0.0566406 3.26953 1.63164 3.26953 3.55664C3.26953 5.48164 4.76953 7.05664 6.60286 7.05664C8.4362 7.05664 9.9362 5.48164 9.9362 3.55664C9.9362 1.63164 8.4362 0.0566406 6.60286 0.0566406ZM6.60286 5.30664C5.6862 5.30664 4.9362 4.51914 4.9362 3.55664C4.9362 2.59414 5.6862 1.80664 6.60286 1.80664C7.51953 1.80664 8.26953 2.59414 8.26953 3.55664C8.26953 4.51914 7.51953 5.30664 6.60286 5.30664ZM6.60286 8.80664C3.35286 8.80664 0.769531 10.3816 0.769531 12.3066V14.0566H9.9362V12.3066H2.4362C2.4362 11.7816 3.9362 10.5566 6.60286 10.5566C8.10286 10.5566 9.26953 10.9941 9.9362 11.4316V9.50664C9.01953 9.06914 7.85286 8.80664 6.60286 8.80664ZM19.1029 0.0566406H13.2695C12.3529 0.0566406 11.6029 0.844141 11.6029 1.80664V12.3066C11.6029 13.2691 12.3529 14.0566 13.2695 14.0566H19.1029C20.0195 14.0566 20.7695 13.2691 20.7695 12.3066V1.80664C20.7695 0.844141 20.0195 0.0566406 19.1029 0.0566406ZM14.1029 12.3066H13.2695V1.80664H14.1029V12.3066ZM19.1029 12.3066H15.7695V1.80664H19.1029V12.3066Z",
    fill: "#4B5768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveVector);
export default __webpack_public_path__ + "static/media/save-vector.55f759d9ab52f15e97c0f9109382ef88.svg";
export { ForwardRef as ReactComponent };